import { useState, useEffect, useMemo } from "react";
import { Row, Col, Button } from "reactstrap";
import ModifyNotificationModal from "../Modal/ModifyNotificationModal";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ConfirmDialog from "../Modal/ConfirmDialog";
import { formatDate } from "../../Utilities/dateUtils";
import axios from "../../services/api/api";
import { useQueryClient } from "@tanstack/react-query";

export default function SingleSuperUserNotification({
  notification,
  schoolData,
  licenseData,
}) {
  const intl = useIntl();
  const schoolsForAdmin = useMemo(
    () => schoolData?.schools ?? [],
    [schoolData]
  );
  const [modifyNotificationModalIsOpen, setModifyNotificationModalIsOpen] =
    useState(false);

  const queryClient = useQueryClient();

  const toggleModifyNotificationModal = () => {
    setModifyNotificationModalIsOpen(!modifyNotificationModalIsOpen);
  };
  const [promptDeleteNotification, setPromptDeleteNotification] =
    useState(false);
  const [licenses, setLicenses] = useState([]);
  const [schools, setSchools] = useState([]);
  const [forUsers, setForUsers] = useState([]);

  const handleDeleteNotification = () => {
    axios
      .post(
        `/User/SetNoticeDeletedStatus?noticeId=${notification.notice.id}&isDeleted=true`
      )
      .then(() => {
        queryClient.invalidateQueries({ queryKey: ["FetchNotifications"] });
        setPromptDeleteNotification(false);
      });
  };

  useEffect(() => {
    let tempLicenses = [];
    notification.forProgramIds.forEach((lic) => {
      tempLicenses.push(
        licenseData.find((license) => license.id === lic)
      );
    });
    setLicenses(tempLicenses);
    let tempSchools = [];
    notification.forSchoolIds.forEach((school) => {
      tempSchools.push(
        schoolsForAdmin.find((scho) => scho.id === school)
      );
    });
    setSchools(tempSchools);
    let tempForUsers = [];
    if (notification.notice.showForTeachers) {
      tempForUsers.push(intl.formatMessage({ id: "Teachers" }));
    }
    if (notification.notice.showForStudents) {
      tempForUsers.push(intl.formatMessage({ id: "Students" }));
    }
    setForUsers(tempForUsers);
  }, [licenseData, schoolsForAdmin, notification, intl]);

  return (
    <>
      <Row
        style={{ border: "1px solid grey", borderRadius: ".2rem" }}
        className="m-2"
      >
        <Col className="my-auto" lg="2">
          <span className="lead">{notification.notice.title}</span>
        </Col>
        <Col lg="2" className="my-auto">
          {formatDate(notification.notice.showFrom, "yyyy-MM-dd")}
        </Col>
        <Col lg="2">
          {licenses.map((license) => {
            return (
              <p
                style={{ marginBottom: ".1rem" }}
                key={notification.notice.id + "licence" + license.id}
              >
                {license.programName}
              </p>
            );
          })}
        </Col>
        <Col lg="2">
          {notification.notice.showForAllCustomers ? (
            <span>
              <FormattedMessage id="AllSchools" />
            </span>
          ) : (
            schools.map((school) => {
              return (
                <p
                  style={{ marginBottom: ".1rem" }}
                  key={notification.notice.id + "school" + school.id}
                >
                  {school.name}
                </p>
              );
            })
          )}
        </Col>
        <Col lg="1">
          {forUsers.map((userType, i) => {
            return (
              <p
                style={{ marginBottom: ".1rem" }}
                key={notification.notice.id + "usr" + i}
              >
                {userType}
              </p>
            );
          })}
        </Col>
        <Col lg="1" className="my-auto text-center">
          {notification.notice.isIntrusive && (
            <FontAwesomeIcon icon="check" className="text-success" />
          )}
        </Col>
        <Col>
          <Button
            outline
            color="danger"
            className="float-end m-1"
            onClick={() =>
              setPromptDeleteNotification(!promptDeleteNotification)
            }
          >
            <FontAwesomeIcon icon={"trash"} />
          </Button>

          <Button
            outline
            color="primary"
            className="float-end m-1"
            onClick={() => {
              toggleModifyNotificationModal();
            }}
          >
            <FormattedMessage id="Edit" />
          </Button>
        </Col>
      </Row>
      <ModifyNotificationModal
        isOpen={modifyNotificationModalIsOpen}
        toggle={toggleModifyNotificationModal}
        notification={notification}
        schoolData={schoolData}
        licenseData={licenseData}
      />
      <ConfirmDialog
        isOpen={promptDeleteNotification}
        toggle={() => setPromptDeleteNotification(!promptDeleteNotification)}
        title={<FormattedMessage id="AreYouSure" />}
        message={intl.formatMessage(
          { id: "DeleteNotificationConfirmation" },
          { title: notification.notice.title }
        )}
        onProceed={handleDeleteNotification}
        danger={true}
      />
    </>
  );
}
